import { useState } from "react";
import "./Filter.css";

import TypeFilter from "../TypeFilter/TypeFilter";
import SelectModal from "../SelectModal/SelectModal";

const Filters = ({
  filter,
  selectedScrip,
  selectedPartner,
  uniqueScrips,
  uniquePartners,
  onFilterChange,
  onScripChange,
  onPartnerChange
}) => {
  const [showScripModal, setShowScripModal] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);

  return (
    <div className="filter-container">

      {/* ✅ TYPE FILTER */}
      <TypeFilter filter={filter} onChange={onFilterChange} />

      {/* ✅ SCRIP SELECT */}
      <button
        className="filter-btn"
        onClick={() => setShowScripModal(true)}
      >
        {selectedScrip === "all" ? "Select Scrip" : selectedScrip}
      </button>

      {/* ✅ PARTNER SELECT */}
      <button
        className="filter-btn"
        onClick={() => setShowPartnerModal(true)}
      >
        {selectedPartner.id === "all" ? "Select Partner" : selectedPartner.name}
      </button>

      {/* ✅ SCRIP MODAL */}
      <SelectModal
        title="Select Scrip"
        items={uniqueScrips}
        selected={selectedScrip}
        onSelect={(value) => onScripChange({ target: { value } })}
        show={showScripModal}
        onClose={() => setShowScripModal(false)}
      />

      {/* ✅ PARTNER MODAL */}
      <SelectModal
  title="Select Partner"
  items={uniquePartners.map(p => ({
    label: p.name,
    value: p.id
  }))}
  selected={selectedPartner.id}
  onSelect={(value) => onPartnerChange({ target: { value } })}
  show={showPartnerModal}
  onClose={() => setShowPartnerModal(false)}
/>

    </div>
  );
};

export default Filters;